/*
 * Copyright (c) 2021, salesforce.com, inc.
 * All rights reserved.
 * SPDX-License-Identifier: BSD-3-Clause
 * For full license text, see the LICENSE file in the repo root or https://opensource.org/licenses/BSD-3-Clause
 */

export default {
    baseStyle: {
        dialog: {borderRadius: 'base'}
    },
    variants: {
        megaNavTopBarModal: {
            dialogContainer: {
                top: '77px'
            }
        },
        megaNavModal: {
            dialogContainer: {
                top: '60px'
            }
        },
        searchModal: {
            dialogContainer: {
                top: '56px',
                overflow: 'hidden',
                height: 'auto'
            }
        },
        searchModalResult: {
            dialogContainer: {
                top: '56px',
                overflow: 'hidden'
            }
        },
        searchModalActiveAnnouncementBar: {
            dialogContainer: {
                top: '90px',
                overflow: 'hidden',
                height: 'auto'
            }
        },
        searchModalResultActiveAnnouncementBar: {
            dialogContainer: {
                top: '90px',
                overflow: 'hidden'
            }
        },
        topBarSearchModal: {
            dialogContainer: {
                top: '77px',
                overflow: 'hidden',
                height: 'auto'
            }
        },
        topBarSearchModalResult: {
            dialogContainer: {
                top: '77px',
                overflow: 'hidden'
            }
        }
    }
}
